const baseApiUrl = 'https://api.drve-hero-marketing-development.devsintra.pl/';
const apiUrl = `${baseApiUrl}api/`;

export const environment = {
  production: false,
  name: 'remote-development',
  appName: 'Marketing hero',
  storageVersion: '1.0.0',
  apiUrl,
  authInterceptorUrls: [apiUrl],
  baseApiUrl,
  mockApiUrl: 'https://localhost:3002/',
  logUrl: '',
  sockets: { url: '' },
  httpRetryConfig: {
    enabled: true,
    verbs: {
      get: { enabled: true, timeout: 60000, maxRetries: 2, retryForStatusesCodes: [500] },
      post: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      patch: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      put: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      delete: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
    },
  },
  loggerConfig: {
    enabled: false,
    maxLogRentention: 20,
    logHttpErrorsWithStatusesCodes: ['0', '4XX', '5XX'],
    logDecoratedExceptions: true,
    logExceptions: true,
    saveLogMessagesInterval: 30000,
    logUrl: '',
    sendLogs: false,
    sendRequestBody: false,
    sendQueryParams: false,
  },
  tagManager: {
    enabled: false,
    apiKey: '',
  },
  facebook: {
    appId: '196904342220404',
    permissionsScope: 'ads_management,ads_read,business_management',
  },
  registerServiceWorker: false,
};
